    <!-- Header -->
    <div class="flex flex-col -m-6">
        <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
            <div class="text-lg font-medium">{{ 'selectLocator' | transloco }}</div>
            <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>

    <form [formGroup]="formGroup" class="flex flex-col px-4 py-12 w-full">
        <!-- Brand -->
        @if (brands.length > 0) {
            <mat-form-field appearance="fill" class="w-full px-2">
                <mat-label>{{ 'brand' | transloco }}</mat-label>
                <mat-select formControlName="marcaCode" class="w-full" [disabled]="data.marca_code">
                    <mat-option>
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (brand of brands; track brand.marca_code) {
                        <mat-option [value]="brand.marca_code">
                            {{ brand.marca_name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (customers.length > 0) {
            <mat-form-field appearance="fill" class="w-full px-2">
                <mat-label>{{ 'customer' | transloco }}</mat-label>
                <mat-select formControlName="clienteCode" class="w-full">
                    <mat-option>
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (customer of customers; track customer.next_cliente_key) {
                        <mat-option [value]="customer.cliente_code">
                            {{ customer.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (projects.length > 0) {
            <mat-form-field appearance="fill" class="w-full px-2">
                <mat-label>{{ 'project' | transloco }}</mat-label>
                <mat-select formControlName="projectId" class="w-full">
                    <mat-option>
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (project of projects; track project.projectId) {
                        <mat-option [value]="project.projectId">
                            {{ project.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (services.length > 0) {
            <mat-form-field appearance="fill" class="w-full px-2">
                <mat-label>{{ 'service' | transloco }}</mat-label>
                <mat-select formControlName="serviceId" class="w-full">
                    <mat-option>
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (service of services; track service.serviceId) {
                        <mat-option [value]="service.serviceId">
                            {{ service.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <div class="flex justify-end">
            <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
                {{ 'cancel' | transloco }}
            </button>
            <button class="mr-2" mat-raised-button color="primary" (click)="accept()" [disabled]="formGroup.invalid">
                {{ 'accept' | transloco }}
            </button>
        </div>
    </form>
    